import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 富文本组件
import Editor from "@/components/Editor"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);
import './assets/icons' // icon
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)
import Pagination from "@/components/Pagination";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, download, handleTree } from "@/utils/ruoyi";
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
// axios.defaults.baseURL = 'http://192.168.1.9:9527';
// Vue.prototype.imgserver = 'http://192.168.1.9:9527';
// 图片服务器地址
axios.defaults.baseURL = 'http://api.hnbywlkj.com';
Vue.prototype.imgserver = 'http://api.hnbywlkj.com';
Vue.prototype.$http = axios

Vue.component('Editor', Editor)
Vue.component('Pagination', Pagination)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')